import { render, staticRenderFns } from "./twoSettlementQuery.vue?vue&type=template&id=b6e5ab14"
import script from "./twoSettlementQuery.vue?vue&type=script&lang=js"
export * from "./twoSettlementQuery.vue?vue&type=script&lang=js"
import style0 from "./twoSettlementQuery.vue?vue&type=style&index=0&id=b6e5ab14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports